import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { SubSink } from "subsink";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { forkJoin, Observable } from "rxjs";
import {
    EmitEvent,
    EventBusService,
} from "../../../../core/services/event-bus.service";
import { NbcLoggerService } from "../../../../shared/logger/nbc-logger.service";
import { SharedDataService } from "../../../../shared/sharedData.service";
import { RemotesQueryService } from "../../../../shared/services/remotesquery.service";
import { OnboardingColorsService } from "../../../../shared/services/onboarding-colors.service";

@Component({
    selector: "onboarding-requestgrid",
    templateUrl: "./request-grid-component.html",
    standalone: false,
})
export class OnboardingRequestComponent implements OnInit, OnDestroy {
    constructor(
        private _eventBus: EventBusService,
        private _onboardingColorsService: OnboardingColorsService,
        private _sharedDataService: SharedDataService,
        public _modalService: BsModalService,
        private _remotesQueryService: RemotesQueryService,
        private log: NbcLoggerService
    ) {}

    private subs = new SubSink();
    gridData: any = {
        items: [],
        query: "",
    };
    hasTalentSu: any = false;
    colors: any | undefined;

    // N/A removed from dropdown options per requirement
    i9VerifyList: any = [
        { id: "1", description: "Sent to Click-Boarding" },
        { id: "2", description: "I9 Documents Verified" },
    ];

    setUpRoleAcccess() {
        const userRoles = window.preload?.user?.userRoles || [];
        this.hasTalentSu = _.some(userRoles, {
            description: "Talent SU",
        });
    }

    buildGrid(dataSource: any) {
        this.setUpRoleAcccess();
        this.gridData = dataSource;
        this.gridData.items.forEach((item: any) => {
            _.assign(item, { checked: false });

            item.requestStatusColor = this.colors.requestStatus.get(
                item.onboardngStatusId.toString()
            );

            // Vendor rows: always display N/A for I9 Verify (read-only, no dropdown)
            if (item.contactType === "Vendor") {
                item.i9VerifyReason = null;
                item.isVendor = true;
                item.isTafSubmittedEnabled = false;
            } else {
                item.isVendor = false;
                // enabled only at Onboarding InProgress (5) or beyond, excluding Cancelled (7)
                item.isTafSubmittedEnabled = item.onboardngStatusId >= 5 && item.onboardngStatusId !== 7;
                // Non-Vendor: restore saved value from the dropdown list
                if (item.i9VerifyReason?.description) {
                    item.i9VerifyReason = this.i9VerifyList.find(
                        (i9) => i9.description === item.i9VerifyReason?.description
                    );
                }
            }
        });
    }

    sortOnColumn(columnName: string): void {
        this._eventBus.emit(
            new EmitEvent(
                "onboard-request:sortOnColumn",
                "changeSortColumn",
                columnName
            )
        );
    }

    updateDetails(item): void {
        this._eventBus.emit(
            new EmitEvent(
                "onboarding-request:updateDetails",
                "updateDetails",
                item
            )
        );
    }

    updateI9VerifyDetails(item): void {
        this._eventBus.emit(
            new EmitEvent(
                "onboarding-request:updateI9VerifyDetails",
                "updateI9VerifyDetails",
                item
            )
        );
    }

    updateTafDetails(item): void {
        this._eventBus.emit(
            new EmitEvent(
                "onboarding-request:updateTafDetails",
                "updateTafDetails",
                item
            )
        );
    }

    cancel(regObject): void {
        this._eventBus.emit(
            new EmitEvent(
                "onboarding-request:cancelReg",
                "cancelReg",
                regObject
            )
        );
    }

    openOnboardingModal(registrationObject) {
        this._eventBus.emit(
            new EmitEvent(
                "Onboarding-Request:openOnboardingModal",
                "openHrOnboardingPositionModal",
                registrationObject
            )
        );
    }

    openEditPositionRequestModal(registrationObject) {
        this._eventBus.emit(
            new EmitEvent(
                "Onboarding-Request:openEditPositionRequestModal",
                "openEditPosReqModal",
                registrationObject
            )
        );
    }

    initSubs(): void {
        this.subs.sink = this._eventBus.on(
            "buildOnboardingRequestGrid",
            (dataSource) => this.buildGrid(dataSource)
        );
    }

    ngOnInit() {
        this.gridData.query =
            this._remotesQueryService.getHrOnboardingRequestTabQuery();
        this.colors = this._onboardingColorsService.getColors();
        this.initSubs();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
